export default __webpack_public_path__ + "static/media/1.6483c9da.png";